import React from 'react';
import DishCard from '../DishCard';

export default function ListLayout({ 
  filtered, 
  categories, 
  cart, 
  onUpdateQuantity 
}) {
    return (
        <div className="layout-list">
            {categories.filter(cat => cat !== 'All').map(cat => {
                const catDishes = filtered.filter(d => d.category === cat);
                if (catDishes.length === 0) return null;
                return (
                    <section key={cat} id={`cat-${cat}`} className="mb-8 pt-2">
                        {/* Elegant Section Header */}
                        <div className="flex flex-col items-center justify-center mb-5">
                            <h2 className="text-lg font-black text-charcoal tracking-widest uppercase">
                                {cat}
                            </h2>
                            <div className="flex items-center gap-2 mt-1">
                                <div className="w-12 h-px bg-slate-300"></div>
                                <div className="w-2 h-2 rounded-full bg-primary/80"></div>
                                <div className="w-12 h-px bg-slate-300"></div>
                            </div>
                        </div>
                        
                        <div className="flex flex-col gap-4">
                            {catDishes.map(dish => (
                                <div key={dish.id}>
                                    <DishCard 
                                        dish={dish} 
                                        quantity={cart[dish.id] || 0} 
                                        onUpdateQuantity={(q, e) => onUpdateQuantity(dish.id, q, e, dish)} 
                                    />
                                </div>
                            ))}
                        </div>
                    </section>
                );
            })}
        </div>
    );
}
